<template>
    <div v-if="shape">
        <GmapMap style="width: 100%; height: 30vh"
                 :center="{lat:shape.position.lat, lng:shape.position.lng}"
                 :map-type-id="mapType"
                 :options="mapOptions"
                 :zoom="mapZoomLevel">

            <gmap-marker :position="{lat:shape.position.lat, lng:shape.position.lng}"
                         :draggable="false"
                         :editable="false"
                         v-if="shape.type === 'marker'"></gmap-marker>

            <gmap-circle :center="shape.position"
                         :radius="shape.radius"
                         :draggable="false"
                         :editable="false"
                         :options="{strokeColor: (plant ? plant.color : 'black'), fillColor: (plant ? plant.color : 'black')}"
                         v-if="shape.type === 'circle'"></gmap-circle>

            <gmap-polygon :paths="shape.paths"
                          :draggable="false"
                          :editable="false"
                          :options="{strokeColor: (plant ? plant.color : 'black'), fillColor: (plant ? plant.color : 'black')}"
                          v-if="shape.type === 'polygon'"></gmap-polygon>
        </GmapMap>

        <!--
        <v-btn dark fab small color="lime" style="position:relative; top:-19vh; left:1vh" @click="mapZoomLevel++">
            <v-icon>mdi-magnify-plus</v-icon>
        </v-btn>

        <v-btn dark fab small color="lime" style="position:relative; top:-19vh; left:2vh" @click="mapZoomLevel--">
            <v-icon>mdi-magnify-minus</v-icon>
        </v-btn>

        <v-btn dark fab small color="lime" style="position:relative; top:-19vh; left:3vh" @click="onType">
            <v-icon>mdi-terrain</v-icon>
        </v-btn>
        -->
    </div>
</template>


<script>

    const ZOOM_LEVEL_DEFAULT = 17
    const MAP_TYPE_HYBRID = 'hybrid'
    const MAP_TYPE_ROADMAP = 'roadmap'

    export default {
        name: 'MapViewer',
        props: ['shape', 'plantId'],
        computed: {
            plant() {
                return this.$store.getters.plantList.find(plant => plant.uuid === this.plantId)
            }
        },
        data: () => ({
            mapType: 'hybrid', //  others are: roadmap, hybrid, satellite, terrain
            mapOptions: {
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false
            },
            mapZoomLevel: ZOOM_LEVEL_DEFAULT,
        }),
        methods: {
            onType() {
                this.mapType = (this.mapType === MAP_TYPE_HYBRID) ? MAP_TYPE_ROADMAP : MAP_TYPE_HYBRID
            },
            updateZoomLevel(shape) {
                this.mapZoomLevel = (shape && shape.zoomLevel) ? shape.zoomLevel : ZOOM_LEVEL_DEFAULT
            }
        },
        watch: {
            shape(newShape /*, oldShape*/) {
                this.updateZoomLevel(newShape)
            }
        },
        mounted() {
            // Initial set zoom-level, afterwards through watch
            this.updateZoomLevel(this.shape)
        }
    }
</script>
